// extracted by mini-css-extract-plugin
export default {"step":"_3LeE1GIR","number":"_1jjYPOAj","body":"_3PpWnZb1","tick":"_2l2cLzGO","sendButton":"_2ZtgNVmt","complete":"_1OzGXB5P","inProgress":"PrmD6AbM","infoBox":"_1ZhI6hPm"};